import { observable, set } from 'mobx';

export interface IDescriptionStatement {
    label: string;
    priority: number;
    content: string;
}

export class DescriptionStatement {
    @observable public label: string = '';
    @observable public priority: number = 0;
    @observable public content: string = '';

    public static fromJson(descriptionStatement: DescriptionStatement): DescriptionStatement {
        const newDescriptionStatement = new DescriptionStatement();
        if (descriptionStatement) {
            set(newDescriptionStatement, descriptionStatement);
        }

        return newDescriptionStatement;
    }

    public toJSON(): IDescriptionStatement {
        return {
            label: this.label,
            priority: this.priority,
            content: this.content
        };
    }
}
